import { Button } from '@wot/components';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import TextInput from '../../components/TextInput/TextInput';
import Select from '../../components/Select/Select';
import PhoneNumberInput from '../../components/PhoneNumberInput/PhoneNumberInput';
import { booktrailApi } from '../../api/booktrail';
import booktrail from '../../assets/images/booktrail.webp'
import { notificationsApi } from '../../api/notifications';
import { toast } from 'react-toastify';
import { SEO } from '../../components/SEO';
export default function BookFreeTrail() {
  const benefits = [
    'One-to-One Learning',
    '2500+ Highly Qualified Teachers',
    '4000+ Subjects',
    'Convenient And Safe',
    'Live and Interactive',
    'Guaranteed Satisfaction',
    'Safe Payments'
  ];

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();
  const [number, setNumber] = useState('');
  const navigate = useNavigate();

  const onSubmit = async (data: any) => {
    try {
      const result = await booktrailApi.booktrail({ ...data, number });
      if (result) {
        const Bookdemo = await notificationsApi.Bookdemo(data);
         if(Bookdemo){
          toast.success(Bookdemo.message)
        }
        reset();
        setNumber('');
        navigate('/thank-you', { replace: true });
      }
    } catch (error) {
      // optionally show a toast or inline error; keeping minimal per request
    }
  };

  return (
    <>
    <SEO 
      title="Book Free Trial - Start Your Learning Journey"
      description="Book a free trial session with WorldoTutor. Experience one-on-one personalized tutoring with our expert teachers. No commitment required!"
      keywords="free trial, book free trial, online tutoring free, trial session, learn online"
      url="/booktrail"
      type="website"
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Book Free Trial - WorldoTutor',
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Book Free Trial - WorldoTutor'
        }
      }}
    />
    <div className="bg-gray-50 font-sans">
      <main className="flex items-center justify-center min-h-screen py-12 px-4">
        <div className="max-w-6xl w-full bg-white shadow-2xl rounded-xl flex flex-col md:flex-row">
          {/* Left Side */}
          <div className="w-full md:w-1/2 p-8 md:p-12">
            <div className="flex justify-center -rotate-[14deg]">
              <img
                src={booktrail}
                alt="Online learning illustration"
                className="max-w-sm"
              />
            </div>
            <h2 className="text-3xl font-bold text-primary mt-8 mb-6 text-center md:text-left">Benefits</h2>
            <ul className="space-y-3">
              {benefits.map((benefit, index) => (
                <li key={index} className="flex items-center text-gray-700">
                  <svg
                    className="w-6 h-6 text-green-500 mr-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Side */}
          <div className="w-full md:w-1/2 p-8 md:p-12 bg-white rounded-r-xl">
            <h2 className="text-5xl font-bold text-primary mb-8 text-center">Book your Free Trial</h2>
            <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
              <TextInput label="Parent's Name" name="parentName" register={register} errors={errors} required />
              <TextInput
                label="Parent's Email"
                name="parentEmail"
                type="email"
                register={register}
                errors={errors}
                required
              />
              <div className="py-3 flex flex-col lg:flex-row lg:items-center items-start gap-4">
                <div className=" w-full flex flex-col">
                  <PhoneNumberInput value={number} containerStyle={{ margin: 0 }} setValue={setNumber} />
                </div>
              </div>
              <TextInput label="Child's Name" name="childName" register={register} errors={errors} required />
             <TextInput label="Subject" name="subject" register={register} errors={errors} required />
              <Select
                label="Select Class"
                name="grade"
                register={register}
                errors={errors}
                required
                options={[
                  { value: 'Class 1', label: 'Class 1' },
                  { value: 'Class 2-3', label: 'Class 2-3' },
                  { value: 'Class 4-6', label: 'Class 4-6' },
                  { value: 'Class 7-9', label: 'Class 7-9' },
                  { value: 'Class 10-12', label: 'Class 10-12' },
                  { value: 'Bachelors Degree', label: 'Bachelors Degree' },
                  { value: 'Masters Degree', label: 'Masters Degree' },
                  { value: 'Doctorate/Ph.D', label: 'Doctorate/Ph.D' },
                   { value: 'others', label: 'Others' }
                ]}
              />
              <div>
                <p className="text-gray-700 mb-2">Do you have a Laptop/PC at home for class?</p>
                <div className="flex items-center space-x-6">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      {...register('device', {
                        required: true
                      })}
                      value="yes"
                      className="form-radio text-primary focus:ring-primary"
                    />
                    <span className="ml-2 text-gray-700">Yes</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      {...register('device', {
                        required: true
                      })}
                      value="no"
                      className="form-radio text-primary focus:ring-primary"
                    />
                    <span className="ml-2 text-gray-700">No</span>
                  </label>
                </div>
                {errors.device && <p className="mt-1 text-sm text-red-500">This field is required</p>}
              </div>
              <Button text="Schedule a Free Trial" block onClick={handleSubmit(onSubmit)} />
            </form>
          </div>
        </div>
      </main>
    </div>
    </>
  );
}
